module.exports = __webpack_public_path__ + "img/2_68.07a60d8a.png";